import { useDebugTools } from '@/hooks'
import { ContextProviders } from 'context'
import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ReactQuery } from './ReactQuery'

interface IProps {
    children: React.ReactNode
}

export function Providers({ children }: IProps) {
    useDebugTools()

    return (
        <ReactQuery>
            <BrowserRouter basename="/">
                <ContextProviders>{children}</ContextProviders>
            </BrowserRouter>
        </ReactQuery>
    )
}
